// extracted by mini-css-extract-plugin
export default {"small":"Modal_small__MMzmA","medium":"Modal_medium__3CZHt","large":"Modal_large__p5v0V","fullscreen":"Modal_fullscreen__HAgLd"};